/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { withLocalization } from 'hocs/localization'
import HomeLayout from 'apps/HomeLayout'
import AuthPage from 'apps/AuthPage'
import ConfirmChangeEmailPage from './routes/ConfirmChangeEmail'

const ConfirmChangeEmail: React.FC<{}> = () => (
  <HomeLayout>
    <AuthPage>
      <Switch>
        <Route path={ROUTES.home.confirmChangeEmail} component={ConfirmChangeEmailPage} exact />
      </Switch>
    </AuthPage>
  </HomeLayout>
)

export default withLocalization('auth.confirmChangeEmail')(ConfirmChangeEmail)
